import * as React from 'react';
import { connect } from 'react-redux';
import { timeStamp, currency } from '~/lib/formatters';
import TransactionHeader from '~/apps/receiver/mobile/components/transactions/TransactionHeader';
import PaginateSimple from '~/common/components/PaginateSimple'
import { getPaycodeAttempList, setPaycodeAttempCurrentPage } from 'apps/receiver/shared/actions/paycodes';
import { defaultTablePageSize } from '~/common/components/consts';
import { navigate } from '~/router';

class TransactionHistory extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.handleHelp = this.handleHelp.bind(this);

    this.state = {
      req: {},
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.paymentAttempts.ui.currentPage && this.props.paymentAttempts.ui.currentPage) {
      if (prevProps.paymentAttempts.ui.currentPage !== this.props.paymentAttempts.ui.currentPage) {
        this.onFetchData(this.props.paymentAttempts.ui.currentPage);
      }
    }
  };

  componentDidMount(): void {
    const { dispatch } = this.props;

    dispatch(setPaycodeAttempCurrentPage(0));
    dispatch(getPaycodeAttempList(0, defaultTablePageSize));
  }

  handleHelp(e) {
    const { onHelp } = this.props;
    e.preventDefault();
    onHelp();
  };

  handleNewPayment = (e) => {
    e.preventDefault();
    navigate('receiver.mobile.createTransaction');
  };

  onChangePage = (pageNum: null) => {
    const { dispatch } = this.props;

    dispatch(setPaycodeAttempCurrentPage(pageNum));
  };

  onFetchData = (page) => {
    const { dispatch } = this.props;

    dispatch(getPaycodeAttempList(page * defaultTablePageSize, defaultTablePageSize));
  };

  renderGrid = () => {
    const { paymentAttempts: { entities, ui: { currentList } } } = this.props;

    return (
      <div className="grid__inn">
        <div className="grid__fw">
          <span className="grid__label">Amount</span>
          <span className="grid__label">Type</span>
          <span className="grid__label">Date</span>
        </div>
        {
          currentList.map((itemId) => {
            const item = entities[itemId];

            return (
              <div
                key={itemId}
                className="grid__row__inline_history">
                <span className="grid__value">${currency(item.amount)}</span>
                <span className="grid__value">{item.type}</span>
                <span className="grid__value">{timeStamp(item.date)}</span>
              </div>
            )
          })
        }
      </div>
    )
  };

  render() {
    const { paymentAttempts: { ui: { currentList, currentPage } } } = this.props;

    return (
      <div className="m--withtable">
        
        <TransactionHeader
          onHelp={this.handleHelp}
          title="History"
          isMain />

        <div className="m__body">
      
          {this.renderGrid()}
          <div className="ReactTable">
            <PaginateSimple
              page={currentPage}
              data={currentList}
              onPageChange={this.onChangePage}
            />
          </div>
        </div>

        <div className="m__foot">
          <div className="m__foot__btns">
            <a
              href="javascript:void(null)"
              className="btn btn--secn btn--lg"
              onClick={this.handleNewPayment}>New Payment</a>
          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    paymentAttempts: state.receiver.paycodeAttempts,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionHistory);
